import { Link } from "react-router-dom";
import NotFoundSvg from "./notfound.svg";

interface Props {}

const NotFound: React.FC<Props> = () => {
  document.title = "پنل دستیار پزشک خوب";

  return (
    <div>
      <div className="flex flex-col items-center justify-center w-1/2 h-screen m-auto">
        <h1 className="text-4xl text-pkc-primary">404</h1>
        <div>
          <NotFoundSvg />
        </div>
        <h4 className="text-lg ">صفحه موردنظر یافت نشد.</h4>
        <Link to="/" className="text-pkc-primary">
          برگشت به صفحه اصلی
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
